import { Component, OnInit, inject } from '@angular/core';
import { BolddeskService } from './bolddesk.service';
import { CONFIG } from '@nano/core/config';

@Component({
  standalone: false,
  selector: 'app-livechat-widget',
  template: '',
  styles: []
})
export class BolddeskComponent implements OnInit {
  private config = inject(CONFIG);
  constructor(private bolddeskService: BolddeskService) {}

  ngOnInit(): void {
    if (this.config.liveChatEnabled) {
      this.bolddeskService.loadChatWidget();
    }
  }
}
